import {Box} from '@mantine/core';
import {RECRUITING_INFO} from '../../../../config/constants/routes';
import {cn} from '../../../../lib/classname';
import {SpTopBottomBanner} from '../../../../shared/components/Banner/SpTopBottomBanner';
import {QUICK_ENTRY_BUTTON} from '../../../../shared/components/EntryButton/GradientEntryButton';
import {CustomTagCompaniesFrameContainers} from '../../../company/components/CustomTagCompaniesFrame/containers';
import {GeneralCarousel} from '../../../generalCarousel/components/GeneralCarousel';
import {useTopPageData} from '../../usecase/useTopPageData';
import {CompanyRankingSection} from './CompanyRankingSection';
import {CompanyPickUpSection} from './CompnyPickupSection';
import {NewColumnSection} from './NewColumn';
import {RecruitmentSection} from './RecruitmentSection';
import {SpecialContentSection} from './SpecialContentSection';
import {CAROUSEL_CONFIG, TOP_PAGE_SECTIONS} from './constants';

type Props = {
  isLogin?: boolean;
  isStudentVerificationRequired?: boolean;
};

export const LoggedInTopRecommend = ({
  isLogin = true,
  isStudentVerificationRequired = false,
}: Props) => {
  const {recruitments, companies, isLoading, quickEntryPagination} =
    useTopPageData({isLogin});

  return (
    <Box className="flex flex-col gap-16">
      <div
        className={cn({
          'hidden pc:block': !isLogin,
        })}
      >
        <GeneralCarousel
          componentId="top-general-carousel-top"
          startIndex={0}
          endIndex={5}
        />
      </div>

      <div id="top-custom-tag-carousel">
        <CustomTagCompaniesFrameContainers
          filterQuery={{}}
          addPaddingLeft={false}
        />
      </div>

      <RecruitmentSection
        componentId="top-recruitment-deadline-carousel"
        title={TOP_PAGE_SECTIONS.DEADLINE.title}
        href={`${RECRUITING_INFO}?order=deadline&allgy=false`}
        recruitments={recruitments.deadline.data?.recruitments}
        isLoading={isLoading.deadline}
      />

      <RecruitmentSection
        componentId="top-recruitment-ranking-carousel"
        title={TOP_PAGE_SECTIONS.RANKING.title}
        recruitments={recruitments.ranking}
        isLoading={isLoading.recruitmentRanking}
        isRanking
        limit={CAROUSEL_CONFIG.RECRUITMENT_RANKING_LIMIT}
        isLogin={isLogin}
        isStudentVerificationRequired={isStudentVerificationRequired}
      />

      <div
        className={cn('pc:hidden w-full py-8 px-20 flex justify-center', {
          hidden: !isLogin,
        })}
      >
        <SpTopBottomBanner type={'top'} />
      </div>

      <RecruitmentSection
        componentId="top-recruitment-recommend-carousel"
        title={TOP_PAGE_SECTIONS.RECOMMEND.title}
        description={TOP_PAGE_SECTIONS.RECOMMEND.description}
        recruitments={recruitments.recommend}
        isLoading={isLoading.recruitments}
      />

      <div
        className={cn('pc:hidden w-full py-8 px-20 flex justify-center', {
          hidden: !isLogin,
        })}
      >
        <SpTopBottomBanner type={'bottom'} />
      </div>

      <RecruitmentSection
        componentId="top-recruitment-recent-carousel"
        title={TOP_PAGE_SECTIONS.RECENT.title}
        href={`${RECRUITING_INFO}?order=recent&allgy=false`}
        recruitments={recruitments.recent.data?.recruitments}
        isLoading={isLoading.recent}
      />

      <RecruitmentSection
        componentId="top-recruitment-quick-entry-carousel"
        title={TOP_PAGE_SECTIONS.QUICK_ENTRY.title}
        description={TOP_PAGE_SECTIONS.QUICK_ENTRY.description}
        recruitments={recruitments.quickEntry}
        isLoading={isLoading.quickEntry}
        onShowMore={() => quickEntryPagination.fetchNextPage()}
        hasMore={quickEntryPagination.hasNextPage}
        isFetchingMore={quickEntryPagination.isFetchingNextPage}
        entryButtonLabel={QUICK_ENTRY_BUTTON.label}
        entryButtonTooltip={QUICK_ENTRY_BUTTON.tooltip}
        entryButtonGradientClassName={QUICK_ENTRY_BUTTON.gradientClassName}
      />

      <CompanyRankingSection
        componentId="top-company-follow-ranking-crsl"
        title={TOP_PAGE_SECTIONS.FOLLOW_RANKING.title}
        rankingItems={
          companies.followRanking.data?.ok
            ? companies.followRanking.data.value.ranking
            : undefined
        }
        isLoading={isLoading.companies}
        isLogin={isLogin}
        isStudentVerificationRequired={isStudentVerificationRequired}
      />

      <NewColumnSection
        componentId="top-new-column-carousel"
        title={TOP_PAGE_SECTIONS.NEW_COLUMN.title}
        isLogin={isLogin}
      />

      <GeneralCarousel
        componentId="top-general-carousel-bottom"
        startIndex={5}
        endIndex={10}
      />

      <CompanyPickUpSection
        componentId="top-company-recommend-carousel"
        title={TOP_PAGE_SECTIONS.RECOMMENDED_COMPANIES.title}
        companies={
          companies.ad.data?.ok ? companies.ad.data.value.companies : undefined
        }
        isLoading={isLoading.companies}
      />

      <RecruitmentSection
        componentId="top-recruitment-gsskt-event-crsl"
        title={TOP_PAGE_SECTIONS.GSSKT_EVENT.title}
        href={`${RECRUITING_INFO}?typeIDs=7`}
        recruitments={recruitments.gssktEvent.data?.recruitments}
        isLoading={isLoading.gssktEvent}
      />

      <SpecialContentSection
        componentId="top-special-content-carousel"
        title={TOP_PAGE_SECTIONS.SPECIAL_CONTENT.title}
      />
    </Box>
  );
};
